import { z } from "zod";

export const examTypes = {
  theoryExam: "Theorieprüfung",
  practicalExam: "Praktische Prüfung",
};

export const ExamTypeEnum = z.enum(Object.keys(examTypes) as [keyof typeof examTypes]);
export type ExamType = z.infer<typeof ExamTypeEnum>;
